import React from 'react';
import GruShell from '../../components/gru/GruShell';
import TabellaStorico from './components/TabellaStorico';

// /gru-storico — registro (append-only) dei movimenti di magazzino, con storno
const GruStoricoPage = () => (
  <GruShell indietroA="/gru-inventory">
    <TabellaStorico />
  </GruShell>
);

export default GruStoricoPage;
